import { render, staticRenderFns } from "./stagehomechart.vue?vue&type=template&id=4879e474"
import script from "./stagehomechart.vue?vue&type=script&lang=js"
export * from "./stagehomechart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports